/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Closing_SubheadlineInputs */

const en_closing_subheadline = /** @type {(inputs: Closing_SubheadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Learn something new in just a few minutes, anywhere, anytime.`)
};

const de_closing_subheadline = /** @type {(inputs: Closing_SubheadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jederzeit und überall in wenigen Minuten etwas Neues lernen.`)
};

const zh_tw_closing_subheadline = /** @type {(inputs: Closing_SubheadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`隨時隨地，花幾分鐘學到一些新東西。`)
};

const zh_cn_closing_subheadline = /** @type {(inputs: Closing_SubheadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`随时随地，花几分钟学到一些新东西。`)
};

const es_closing_subheadline = /** @type {(inputs: Closing_SubheadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En cualquier momento, aprende algo nuevo en solo unos minutos.`)
};

const fr_closing_subheadline = /** @type {(inputs: Closing_SubheadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`N'importe où, n'importe quand, apprends quelque chose de nouveau en quelques minutes.`)
};

const it_closing_subheadline = /** @type {(inputs: Closing_SubheadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ovunque tu sia, impara qualcosa di nuovo in pochi minuti.`)
};

const pt_br_closing_subheadline = /** @type {(inputs: Closing_SubheadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A qualquer momento, aprenda algo novo em poucos minutos.`)
};

const ja_closing_subheadline = /** @type {(inputs: Closing_SubheadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いつでもどこでも、数分で何か新しいことが学べる。`)
};

const ko_closing_subheadline = /** @type {(inputs: Closing_SubheadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`언제 어디서든, 몇 분이면 새로운 걸 배울 수 있어요.`)
};

const ru_closing_subheadline = /** @type {(inputs: Closing_SubheadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`В любой момент за пару минут узнавай что-то новое.`)
};

const th_closing_subheadline = /** @type {(inputs: Closing_SubheadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ทุกที่ทุกเวลา แค่ไม่กี่นาทีก็ได้เรียนรู้สิ่งใหม่ๆ`)
};

const tr_closing_subheadline = /** @type {(inputs: Closing_SubheadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Her an, birkaç dakikada yeni bir şey öğren.`)
};

const ar_closing_subheadline = /** @type {(inputs: Closing_SubheadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`في أي وقت ومكان، تعلّم شيئًا جديدًا في دقائق.`)
};

/**
* | output |
* | --- |
* | "Learn something new in just a few minutes, anywhere, anytime." |
*
* @param {Closing_SubheadlineInputs} inputs
* @param {{ locale?: "en" | "de" | "zh_tw" | "zh_cn" | "es" | "fr" | "it" | "pt_br" | "ja" | "ko" | "ru" | "th" | "tr" | "ar" }} options
* @returns {LocalizedString}
*/
export const closing_subheadline = /** @type {((inputs?: Closing_SubheadlineInputs, options?: { locale?: "en" | "de" | "zh_tw" | "zh_cn" | "es" | "fr" | "it" | "pt_br" | "ja" | "ko" | "ru" | "th" | "tr" | "ar" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Closing_SubheadlineInputs, { locale?: "en" | "de" | "zh_tw" | "zh_cn" | "es" | "fr" | "it" | "pt_br" | "ja" | "ko" | "ru" | "th" | "tr" | "ar" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_closing_subheadline(inputs)
	if (locale === "de") return de_closing_subheadline(inputs)
	if (locale === "zh_tw") return zh_tw_closing_subheadline(inputs)
	if (locale === "zh_cn") return zh_cn_closing_subheadline(inputs)
	if (locale === "es") return es_closing_subheadline(inputs)
	if (locale === "fr") return fr_closing_subheadline(inputs)
	if (locale === "it") return it_closing_subheadline(inputs)
	if (locale === "pt_br") return pt_br_closing_subheadline(inputs)
	if (locale === "ja") return ja_closing_subheadline(inputs)
	if (locale === "ko") return ko_closing_subheadline(inputs)
	if (locale === "ru") return ru_closing_subheadline(inputs)
	if (locale === "th") return th_closing_subheadline(inputs)
	if (locale === "tr") return tr_closing_subheadline(inputs)
	return ar_closing_subheadline(inputs)
});